const ColumnsSlider = function() {
    function ColumnsSlider() {
        this.selector = {
            desktopslider: document.getElementById("desktop-column-slider"),
            slides: document.querySelectorAll(".hero-area .column-slides"),
            mobileslider: document.getElementById("mobile-column-slider")
        }
        this.load()
    }
    ColumnsSlider.prototype.load = function() {
        var _ = this;
        if(_.selector.desktopslider) {
            $('#desktop-column-slider').slick({
                infinite: true,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                responsive: [
                    {
                      breakpoint: 992,
                      settings: {
                        dots: true
                      }
                    }
                  ]
            });
        }
        if(_.selector.slides.length > 0) {
            _.selector.slides.forEach(slide => {
                slide.addEventListener("mouseover", event => {
                console.log(event.target.closest(".column-slides"));
                    $('#desktop-column-slider').slick('slickGoTo', parseInt(event.target.closest(".column-slides").dataset.index) - 1);
                })
            })
        }
    }
    ColumnsSlider = new ColumnsSlider;
}

ColumnsSlider();